module.exports = __webpack_public_path__ + "static/media/wuyi_bg3.6b204569.jpg";